window.k1ScrollToTop = {
	getButtonScrollToTop: function () {
		return document.querySelector('.k1-scroll-to-top-js');
	},
	showButton: function () {
		let body = document.querySelector('body').getBoundingClientRect();
		if (body.top < -1000) {
			// console.log(button)
			window.dremVars.scrollToTopButton.classList.add('show')
		} else {
			window.dremVars.scrollToTopButton.classList.remove('show')
		}
	},
	scrollToTop: function () {
		window.scrollY = 0;
		document.querySelector('html').scrollIntoView({
			behavior: "smooth"
		});
	},
	init: function () {
		this.showButton();
	}
};
window.dremVars.scrollToTopButton = window.k1ScrollToTop.getButtonScrollToTop();
window.addEventListener('scroll', function () {
	self.k1ScrollToTop.init();
});
window.dremVars.scrollToTopButton.addEventListener('click', function () {
	window.k1ScrollToTop.scrollToTop();
});